import { action, makeAutoObservable } from "mobx";

class SequenceTimelineStoreInstance {
  zoom: number = 1.0; // 1x
  width: number = 0;  // virtual timeline width (px)
  tracksContainerWidth: number = 0; // viewport width (px)
    draggedClips: Record<string, true> = {};
  leftPadSeconds: number = 0.5; // default negative-time lead-in

  constructor() {
    makeAutoObservable(this, {
      setZoom: action,
      setWidth: action,
      setTracksContainerWidth: action,
      setLeftPadSeconds: action,
    });
  }

    setDraggingClip(clipId: string, isDragging: boolean) {
        if (isDragging) {
            this.draggedClips[clipId] = true;
        } else {
            delete this.draggedClips[clipId];
            // delete this.leftTrimPreviewSecByClipId[clipId];
            // delete this.rightTrimPreviewSecByClipId[clipId];
        }
    }

  setZoom(z: number) {
    this.zoom = Math.max(0.1, Math.min(8, z));
  }

  setWidth(px: number) {
    this.width = Math.max(0, px);
  }

  setTracksContainerWidth(px: number) {
    this.tracksContainerWidth = Math.max(0, px);
  }

  setLeftPadSeconds(seconds: number) {
    this.leftPadSeconds = Math.max(0, Number.isFinite(seconds) ? seconds : 0);
  }
}

export const SequenceTimelineStore = new SequenceTimelineStoreInstance();


